package com.essntl.features.proposal.domain.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.proposal.domain.use_case")
class ProposalUseCaseModule